import { create } from "zustand"
import { persist } from "zustand/middleware"
import { mutative } from "zustand-mutative"

type TreasureChestAlertModalStoreState = {
  dismissedChestIds: string[]
}

type TreasureChestAlertModalStoreActions = {
  isDismissed: (chestId: string) => boolean
  dismiss: (chestId: string) => void
  reset: () => void
}

type TreasureChestAlertModalStore = TreasureChestAlertModalStoreState &
  TreasureChestAlertModalStoreActions

export const TreasureChestAlertModalStore =
  create<TreasureChestAlertModalStore>()(
    persist(
      mutative((set, get) => ({
        dismissedChestIds: [],
        isDismissed: chestId => {
          return get().dismissedChestIds.includes(chestId)
        },
        dismiss: chestId => {
          set(state => {
            if (!state.dismissedChestIds.includes(chestId)) {
              state.dismissedChestIds.push(chestId)
            }
          })
        },
        reset: () => {
          set(state => {
            state.dismissedChestIds = []
          })
        },
      })),
      {
        name: "treasure-chest-alert-modal",
        partialize: state => ({
          dismissedChestIds: state.dismissedChestIds,
        }),
      },
    ),
  )
